import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Dropdown } from 'common-components'
import { FormGroup } from 'reactstrap'
import { getSukhapabDekDeeOptionsPlans, getSelectCampaignPlan } from '../selectors'
import { selectSukhapabDekDeePlan } from '../../actions'

const BasicPlanSelection = ({ sukhapabDekDeeOptionsPlans, selectedSukhapabDekDeePlans, selectSukhapabDekDeePlan }) => {
  return (
    <FormGroup className={'basic-plan-selection item basic'}>
      <div className="form-group-title">
        <span className="form-group-title-text">สัญญาหลัก</span>
      </div>
      <div className="options option-labels">
        <label>เลือกแผน</label>
      </div>
      <Dropdown
        className="basic-plan form-control"
        options={sukhapabDekDeeOptionsPlans}
        onChange={(planCode) => {
          selectSukhapabDekDeePlan(planCode)
        }}
        value={selectedSukhapabDekDeePlans}
      />
    </FormGroup>
  )
}

const mapStateToProps = (state) => ({
  sukhapabDekDeeOptionsPlans: getSukhapabDekDeeOptionsPlans(state),
  selectedSukhapabDekDeePlans: getSelectCampaignPlan(state),
})

const mapDispatchToProps = (dispatch) => ({
  selectSukhapabDekDeePlan: bindActionCreators(selectSukhapabDekDeePlan, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(BasicPlanSelection)
